/*
 * pogi-press-bar — opens the branded, tabbed press-mentions modal (§13.4) from
 * the "Read the press" trigger. Native <dialog> (Esc + backdrop + close button
 * dismiss), body-scroll lock while open, and publication tabs that swap which
 * mention quote is shown (one at a time).
 */
class PogiPressBar extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('[data-press-modal]');
    if (!this.modal) return;
    this.tabs = Array.from(this.modal.querySelectorAll('[data-press-tab]'));
    this.panels = Array.from(this.modal.querySelectorAll('[data-press-panel]'));

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-press-open]')) {
        e.preventDefault();
        this.open();
        return;
      }
      if (e.target.closest('[data-press-close]')) {
        this.modal.close();
        return;
      }
      const tab = e.target.closest('[data-press-tab]');
      if (tab) {
        this.select(tab.getAttribute('data-press-tab'));
        return;
      }
      // backdrop click — the dialog element itself is the click target
      if (e.target === this.modal) this.modal.close();
    });

    // restore scroll whenever the dialog closes (close button, Esc, .close())
    this.modal.addEventListener('close', () => {
      document.body.style.overflow = this._prevOverflow || '';
      document.body.style.paddingRight = this._prevPaddingRight || '';
    });
  }

  select(index) {
    const i = String(index);
    this.tabs.forEach((tab) => {
      const on = tab.getAttribute('data-press-tab') === i;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      const on = panel.getAttribute('data-press-panel') === i;
      panel.classList.toggle('is-hidden', !on);
    });
  }

  open() {
    this.select(0); // reset to the first tab each time it opens
    this._prevOverflow = document.body.style.overflow;
    this._prevPaddingRight = document.body.style.paddingRight;
    // POGI: compensate the scrollbar width so locking scroll doesn't shift the page right.
    const sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = `${sbw}px`;
    document.body.style.overflow = 'hidden';
    if (typeof this.modal.showModal === 'function') this.modal.showModal();
    else this.modal.setAttribute('open', '');
  }
}

if (!customElements.get('pogi-press-bar')) {
  customElements.define('pogi-press-bar', PogiPressBar);
}
